import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBathMan1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bath-man-1, man, male"><circle cx="12" cy="4" r="2.25" stroke="currentColor" strokeWidth="1.5"/><path d="M15.25 22.25V16.25H17.25V8.75H6.75V16.25H8.75V22.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBathMan1;
